export default {
    message: {
        tiers: {
            t1: {
                label: "Stand-Alone",
                desc: "<p>Vereinheitlichter Zugriff auf alle virtuellen, Web- und SaaS-Anwendungen, Schutz von Benutzern, Anwendungen und Daten mithilfe durchgängiger kontextbasierter Sicherheitskontrollen.</p><p>Bietet VPN-freien Proxy- und SSO-Zugriff auf Web-, SaaS-, virtuelle und Mobilanwendungen sowie Schutz vor schädlichen Inhalten, Keyloggern und Malware zur Bildschirmaufzeichnung.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Umfassende Workspace-Lösung für Mitarbeiter, die einen vollständigen digitalen Arbeitsplatz mit granularer Sicherheit, aber keine virtuellen Anwendungen und Desktops benötigen.</p><p>Umfasst alle Funktionen von Workspace Standard sowie erweiterte Sicherheitskontrollen für SaaS und das Internet, einheitliches Endgeräte-Management und Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Umfassende Workspace-Lösung einschließlich Optionen zur hybriden Bereitstellung von Citrix Virtual Apps and Desktops.</p><p>Umfasst alle Funktionen von Workspace Premium sowie eine Cloud-Management-Option für Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}